export class AdminApproveProfileTextsController {
  constructor($scope, $modal, UserService, $timeout) {
    $scope.vm = this;
    this.scope = $scope;
    this.modal = $modal;
    this.timeout = $timeout;
    this.UserService = UserService;
    this.scope.allUsers = {};
    this.scope.allUsersSelected = { status: false };
    this.scope.usersSelected = {};

    this.scope.pagination = {
      total: 0,
      currentPage: 1,
      limit: 12
    };

    this.scope.feedback = {
      toId: '',
      fromId: '',
      reason: '',
      extraMessage: ''
    };

    this.scope.showModal = {
      feedback: false
    };

    this.scope.feedbackMessages = [
      {
        'id': 1,
        'text': 'Personal',
        'value': 'Estimado Usuario:\n\n\n\n\n\n' +
        '\nAtentamente\n' + 'Datingchile.cl' + '\n'
      },
		  {
        'id': '2',
        'text': 'Generico',
        'value': 'Disculpa, hemos rechazado tu texto de perfil por alguna de las siguientes razones\n•'+
                 '    Una dirección de e-mail\n•'+
                 '    Un texto poco serio\n•'+
                 '    Un número de teléfono\n•'+
                 '    Un nombre personal completo\n•'+
                 '    Una promoción comercial\n•'+
                 '    Un link de referencia\n'+
                 'Por favor modifica tu texto desde el menú de "editar perfil" y aceptaremos de inmediato. '+
                 'No olvides que tu privacidad y seguridad es nuestra principal preocupación' +
                 '\nAtentamente\n' + 'Datingchile.cl' + '\n'
      }
    ];

    this.init();
  }

  init() {
    this.scope.changeLimit = () => {
      this.timeout.cancel(this.limitTimout);

      this.limitTimout = this.timeout(() => {
        this.scope.getUsers(1);
      }, 200);
    }

    this.scope.getUsers = (page) => {
      this.scope.usersSelected = {};
      this.UserService.getProfileTextUnapproved(page, this.scope.pagination.limit).then((response) => { let data = response.data;
        this.scope.allUsers = data.data;
        this.scope.pagination.total = data.itemCount;
        _.forEach(this.scope.allUsers, (user) => {
          this.scope.usersSelected[user._id] = false;
        })
      }).catch((response) => { let err = response.data;
        console.log(err);
      })
    }

    this.scope.openFeedbackModal = () => {
      var stop = true;

      _.forEach(this.scope.usersSelected, (value, key) => {
        if(value) {
          stop = false;
        }
      });

      if(stop) {
        return;
      }

      this.scope.hideModal();
      this.scope.showModal.feedback = true;
      //this.scope.feedback.toId = userId;
      $('#modal').modal('show');
    }

    this.scope.hideModal = () => {
      this.scope.showModal.feedback = false;
      this.scope.showModal.image = false;
    };

    this.scope.getUsers(this.scope.pagination.currentPage);

    this.scope.selectAllUsers = () => {
      let check = this.scope.allUsersSelected.status;

      _.forEach(this.scope.usersSelected, (user, key) => {
        this.scope.usersSelected[key] = !!check;
      })
    }

    this.scope.onChangeTitle = (data, user) => {
      this.UserService.updateUser(user)
        .catch((response) => { let error = response.data;
          console.log(error);
        });
    }

    this.scope.onChangeDescription = (data, user) => {
      this.UserService.updateUser(user)
        .catch((response) => { let error = response.data;
          console.log(error);
        });
    }

    this.scope.approveUsers = () => {
      if(!confirm('Do you really want to approve profile text?')) {
        return;
      }

      var countdown = 0;

      this.scope.allUsersSelected.status = false;
      _.forEach(this.scope.usersSelected, (user, key) => {

        if(this.scope.usersSelected[key]) {
          countdown++;
          var index = _.findIndex(this.scope.allUsers, {'_id': key});

          // this.scope.allUsers[index].informationPersonal.shortDescription = angular.copy(this.scope.allUsers[index].informationPersonal.shortDescriptionForApprove);
          this.scope.allUsers[index].informationPersonal.shortDescriptionApproved = true;

          this.UserService.approveProfileText(this.scope.allUsers[index]._id, this.scope.allUsers[index].informationPersonal)
          .then((response) => { let data = response.data;
            // Call refresh when all queries will be completed
            countdown--;
            if (countdown === 0)
              this.refreshPage();
            })
          .catch((response) => { let err = response.data;
            console.log(err);
            // Call refresh when all queries will be completed
            countdown--;
            if (countdown === 0)
              this.refreshPage();
          });
        }
      });
    }

    this.scope.sendFeedback = (formReport) => {

      if (!formReport.$valid) {
        this.formValidationForReport(formReport);
        return;
      }

      if (this.scope.feedback.reason === "" || this.scope.feedback.extraMessage === "") {
        this.toastr.error('Feedback hasn\'t sent. You must add message');
        return;
      }

      this.scope.rejectText();
    }

  this.scope.rejectText = () => {
    if(!confirm('Do you really want to approve reject text?')) {
      return;
    }

    var countdown = 0;

    this.scope.allUsersSelected.status = false;
    _.forEach(this.scope.usersSelected, (user, key) => {

      if(this.scope.usersSelected[key]) {
        countdown++;
        var index = _.findIndex(this.scope.allUsers, {'_id': key});

        this.UserService.rejectProfileText(this.scope.allUsers[index]._id, {
          reason: this.scope.feedback.reason.text,
          motivation: this.scope.feedback.extraMessage
        })
        .then((response) => { let data = response.data;
          // Call refresh when all queries will be completed
          countdown--;
            if (countdown === 0) {
              this.refreshPage();

              // Reset fields
              this.scope.feedback.reason = '';
              this.scope.feedback.extraMessage = '';

              $('#modal').modal('hide');
            }
          })
        .catch((response) => { let err = response.data;
          console.log(err);
          // Call refresh when all queries will be completed
          countdown--;
          if (countdown === 0) {
            this.refreshPage();

            // Reset fields
            this.scope.feedback.reason = '';
            this.scope.feedback.extraMessage = '';

            $('#modal').modal('hide');
          }
        });
      }
    });
  }
}

  /**
   * Refresh page content and pagination
   */
  refreshPage() {
    // Calculates amount of users have been approved (were removed from total)
    var itemsRemoved = _.size(this.scope.usersSelected);
    _.forEach(this.scope.usersSelected, (val, key) => {
      if (val === false) { itemsRemoved--; }
    } );

    // Stay on the current page unless the removals put it past the end of the
    // shortened list.
    var lastPage = Math.max(1, Math.ceil((this.scope.pagination.total - itemsRemoved) / this.scope.pagination.limit));
    var page = Math.min(this.scope.pagination.currentPage, lastPage);

    this.scope.getUsers(page);
  }
}
